import React from 'preact/compat';
import { useMemo } from 'preact/hooks';

import ToggleButton from '@mui/material/ToggleButton';
import Typography from '@mui/material/Typography';

import colors from '../colors';
import CheckboxCheckedIcon from '../icons/CheckboxCheckedIcon';
import CheckboxUncheckedIcon from '../icons/CheckboxUncheckedIcon';

const LauncherFeatureFilterCheckbox = ({ selected, setSelected, label }) => {
    const toggleSelected = useMemo(() => (e) => {
        setSelected(!selected);
    }, [selected, setSelected]);

    return <ToggleButton
        value={selected}
        onClick={toggleSelected}
        sx={{
            height: "44px",
            color: colors.secondaryText,
            borderRadius: "8px",
            borderStyle: 'solid',
            borderWidth: '1px',
            borderColor: colors.optionBorder,
            boxShadow: colors.optionShadow,
            marginLeft: '24px',
            textTransform: 'none',
            '&.Mui-selected': {
                fill: colors.secondaryText
            },
            '& .MuiSvgIcon-root': {
                fontSize: '20px',
                fill: colors.option,
                stroke: colors.inputBorder
            },
            '& .MuiTypography-root': {
                paddingTop: '2px',
                marginLeft: '16px',
                fontWeight: 600
            }
        }}
    >
        {selected ? <CheckboxCheckedIcon /> : <CheckboxUncheckedIcon />}
        <Typography> {label} </Typography>
    </ToggleButton>;
};

export default LauncherFeatureFilterCheckbox;
